module.exports = __webpack_public_path__ + "img/2.9ad2b682.png";